import { defineComponent, h, markRaw } from 'vue';
import { QBtn, QIcon, QMenu, QList, QItem, QItemSection, QItemLabel, QSeparator, QInput, QLinearProgress, QTooltip } from 'quasar';
import BaseComponent from './BaseComponentMixin.jsx';
import careHelpfulFunctions from '../careHelpfulFunctions.jsx';
import utils from '../../Shared/utils.jsx';
import EventBus from '../event-bus.js';
import methods from '../../Shared/methods';
import { debounce } from "lodash";

import { AgGridVue } from "ag-grid-vue3";

import AgContentDef from './AgContentDef.jsx';

import TranslationContainer from './TranslationContainer.jsx';

var baseMixin = {
    mixins: [BaseComponent],
    components: {
        AgGridVue,
        AgContentDef,
        TranslationContainer,
        QBtn,
        QIcon,
        QMenu,
        QList,
        QItem,
        QItemSection,
        QItemLabel,
        QSeparator,
        QInput,
        QLinearProgress,
        QTooltip,
    },
    data: () => ({
        unique_id: '',
        dataGridRefName: null,
        gridcomponent: null,
        menu_is_open: false,

        schemaurl: null,
        schemaraw: null,
        rowClassExpr: null,
        modelurl: null,
        modelvalue: null,
        schema: null,
        modelfunc: null,
        storageFunc: null,
        showFilter: false,
        rowClassExpr: null,
        headerControls: {},
        addrowdata: [],
        addrowdata_todo: 0,
        addrowdata_count: 0,
        addrowdata_inprogress: false,
        addrowdata_promises: [],

        selectedRowKeys: [],
        selected_rows: {},
        selectedRowsData: [],
        columnDefs: null,

        displayMode: 'full',
        pageSizes: [10, 15, 20, 25, 30, 35, 40, 45, 50],
        showPageSizeSelector: true,
        showInfo: true,
        showNavButtons: true,
        scrollMode: "virtual",

        loading: false,
        selectableexpn: null,

        pagination: false,
        columns_visible: [], // Array of boolean to show/hide a column
        columnDefsVersion: 0, // Bumped by RestoreDefaults so agColumnDefs is rebuilt from the reset visibility
        allowExportAll: true,
        useBuiltInExport: false,
        // Don't allow these to be reactive, messes up reactivity for some reason
        // gridApi: null,
        // columnApi: null,

        searchText: '',
        jumpToValue: '',
        HasFilters: false,
		serverSideSelectionState: {},
        modelurl_watch$: null,
        static_vars: markRaw({
            rowDataTemp: null,
            rowIndex: -1,
            colFuncCache: {},
        })
    }),
    props: {
    },
    created() {
        this.unique_id = utils.generateUUID();
        this.dataGridRefName = `dataGrid_${utils.generateUUID()}`;
        // Non-reactive: last known scroll while the grid is laid out / interactive.
        // Quasar KeepAlive (Vue3 BasicTab etc.) detaches the DOM and AG Grid reopens at top;
        // Vue2 Vuetify v-tabs-items kept panels mounted so this was unnecessary.
        this._savedGridScroll = { top: 0, left: 0, firstRow: 0 };
        this._onGridBodyScroll = (e) => this.captureGridScrollFromEvent(e);

        if (this.controlData.DisableLocalStorage != undefined && this.controlData.DisableLocalStorage != null) {
            this.storageFunc = utils.compile(this, this.controlData.DisableLocalStorage);
        }

        if (this.controlData.SchemaURL)
        {
            this.schemaurl = utils.compile(this, this.controlData.SchemaURL);

            this.schemaurl_watch$ = this.$watch(
                function () {
                    try {
                        return utils.evaluate(this.schemaurl, this);
                    }
                    catch (e)
                    {
                        utils.warn('BasicGrid schemaurl ' + this.controlData.SchemaURL + ' failed to evaluate: ' + e);
                        return '';
                    }
                },
                function (val, oldval) {
                    this.Refresh(true);
                }
            );
        }
              

        if ((this.controlData.DataType === 'URL' || this.controlData.DataType === undefined) && this.controlData.DataURL)
        {
            this.modelurl = utils.compile(this, this.controlData.DataURL);
        }
        else if (this.controlData.DataType === 'Raw' && this.controlData.Data)
        {
            this.modelvalue = utils.compileObject(this, this.controlData.Data);
        }

        if (this.controlData.PersistenceKey)
        {
            this.persistencekeyexpn = utils.compile(this, this.controlData.PersistenceKey);
        }

        // Special case here to handle interpolated column definitions (used in Advanced History reports)
        if (typeof this.controlData.ColumnDefs === 'string' && (this.controlData.ColumnDefs.includes('{#') || this.controlData.ColumnDefs.includes('{%'))) {
            const columnDefEval = utils.compileObject(this, this.controlData.ColumnDefs);
            this.columnDefs = utils.evaluateObject(columnDefEval, this);

            if (this.controlData.ColumnDefs.includes('{%')) {
                const self = this;
                this.columnDefs_watch$ = this.$watch(
                    function () { return utils.evaluateObject(columnDefEval, self); },
                    function (newv) {
                        this.columnDefs = newv;
                    }
                );
            }
        }
        else
            this.columnDefs = this.controlData.ColumnDefs || [];

        if (this.columnDefs) {
            for (let i = 0; i < this.columnDefs.length; i++) {
                const cdef = this.columnDefs[i];
                if (cdef.ContentDefs) {
                    for (let j = 0; j < cdef.ContentDefs.length; j++) {
                        const contentdef = cdef.ContentDefs[j];
                        if (contentdef.DisplayExpression) {
                            contentdef.displayExpression = utils.compileExpression(this, contentdef.DisplayExpression);
                        }
                    }
                }
                else if (cdef.Field) {
                    cdef.column_eval = new Function('model', 'return model.' + cdef.Field + ' || "";');
                }
            }
        }

        // Read this.columns_visible from local storage if present
        const cv = this.System.LocalStorage(this.storageKey + '-columns_visible');
        
        if (cv) {
            const cvObj = JSON.parse(cv);

            if (Array.isArray(cvObj)) {
                this.columns_visible = cvObj;
            }
        }

        if (Array.isArray(this.columnDefs)) {
            if (!cv || this.columns_visible.length !== this.columnDefs.length) {
                this.columns_visible = this.columnDefs.map(d => {
                    if (!('Visible' in d)) {
                        return true;
                    }

                    if (typeof d.Visible === "string" && d.Visible.length > 0) {
                        let evalExpression = utils.compile(this, d.Visible);
                        return utils.evaluateObject(evalExpression, this) === true;
                    }
                    
                    return d.Visible === true;
                });
            }
        }


        if (this.controlData.SelectOptions && this.controlData.SelectOptions.Enable && this.controlData.SelectOptions.SelectableExpression)
            this.selectableexpn = utils.compileExpression(this, this.controlData.SelectOptions.SelectableExpression, 'row');        
        // This is a temporary non-reactive copy of the visibility flags for use when generating the columns.
        // We don't want the columns to react to this object changing since we'll be calling into the grid API
        // directly to toggle a column's visibility (much faster).
        this.init_columns_visible = [...this.columns_visible];

        // Read pagination settings if present
        const pg = this.System.LocalStorage(this.storageKey + '-standard_pagination');
        if (typeof pg === 'string')
            this.pagination = pg == 'true';

        // Subscribe to a UIAction_GridRefresh event
        this.$on('Action-GridRefresh', this.performGridRefresh);
        this.$on('Action-GridClearSelectedRows', this.performGridClearSelectedRows);

        EventBus.$on('Action-GridRefresh', this.performGridRefresh);
        EventBus.$on('Action-GridClearSelectedRows', this.performGridClearSelectedRows);

        // Subscribe by name so Target can be directed to a specific container
        if (this.controlData.Name) {
            this.$on(`Action-GridRefresh:${this.controlData.Name}`, this.performGridRefresh);
            EventBus.$on(`Action-GridRefresh:${this.controlData.Name}`, this.performGridRefresh);

            this.$on(`Action-GridClearSelectedRows:${this.controlData.Name}`, this.performGridClearSelectedRows);
            EventBus.$on(`Action-GridClearSelectedRows:${this.controlData.Name}`, this.performGridClearSelectedRows);
        }

        // AdditionalRowData contains expressions and async lookups that are evaluated once for the whole
        // dataset at load time. As the data materializes, rows that reference it will get updated.
        if (this.controlData.AdditionalRowData)
            for (let i = 0; i < this.controlData.AdditionalRowData.length; i++) {
                const add = this.controlData.AdditionalRowData[i];
                this.addrowdata.push({
                    name: add.Name,
                    initValue: add.InitialValue ? utils.compileObject(this, add.InitialValue) : null,
                    contentDefs: add.ContentDefs.map(c => ({
                        displayexpr: c.DisplayExpression ? utils.compileExpression(this, c.DisplayExpression) : null,
                        type: c.DataType,
                        valueexpr: c.Value ? utils.compileObject(this, c.Value) : null,
                        urlexpr: (c.URL && c.DataType == 'AsyncLookup') ? utils.compile(this, c.URL) : null,
                        cache: c.CacheReply !== undefined ? c.CacheReply : true,
                    }))
                });
            }
    },
    unmounted() {
        utils.log('Full BasicGrid unmounted()');
        this.detachGridScrollListener();
        if (this.schemaurl_watch$) this.schemaurl_watch$(); // disposes of the watcher
        if (this.schemaraw_watch$) this.schemaraw_watch$();
        if (this.modelurl_watch$) this.modelurl_watch$();
        if (this.modelvalue_watch$) this.modelvalue_watch$();
        if (this.columnDefs_watch$) this.columnDefs_watch$();

        this.$off('Action-GridRefresh', this.performGridRefresh);
        this.$off('Action-GridClearSelectedRows', this.performGridClearSelectedRows);

        EventBus.$off('Action-GridRefresh', this.performGridRefresh);
        EventBus.$off('Action-GridClearSelectedRows', this.performGridClearSelectedRows);

        if (this.controlData.Name) {
            this.$off(`Action-GridRefresh:${this.controlData.Name}`, this.performGridRefresh);
            EventBus.$off(`Action-GridRefresh:${this.controlData.Name}`, this.performGridRefresh);

            this.$off(`Action-GridClearSelectedRows:${this.controlData.Name}`, this.performGridClearSelectedRows);
            EventBus.$off(`Action-GridClearSelectedRows:${this.controlData.Name}`, this.performGridClearSelectedRows);
        }
        if (this.watch_date_value$)
            this.watch_date_value$();
        if (this.rowclass_watch$)
            this.rowclass_watch$();
        if (this._isvisible_scroll$)
            this._isvisible_scroll$();
    },
    // KeepAlive (Quasar QTabPanels keep-alive) — nested grids get these hooks.
    deactivated() {
        this.captureGridScrollPosition();
    },
    activated() {
        this.$nextTick(() => this.restoreGridScrollPosition());
    },
    computed: {
        dataGrid: function () {
            const r = this.$refs[this.dataGridRefName];
            if (r)
                return r.instance;
            else
                return undefined;
        },
        Model: function () {
            if (this.modelfunc)
                return this.modelfunc;
            else
                return null;
        },
        useLocalStorage: function () {
            if (this.storageFunc) {
                return !utils.evaluate(this.storageFunc, this);
            }

            return true;
        },
        storageKey: function () {
            if (this.persistencekeyexpn) {
                const key = utils.evaluate(this.persistencekeyexpn, this);
                return `basicGrid-${this.parentType}-${key || this.controlData.Name || 'unnamed'}-${this.controlData.$objectid || 'noid'}`;
            }
            else
                return `basicGrid-${this.parentType}-${this.controlData.Name || 'unnamed'}-${this.controlData.$objectid || 'noid'}`;
        },
        schemaurlvalue: function () {
            if (this.schemaurl)
                return utils.evaluate(this.schemaurl, this);
            else
                return '';
        },
        modelurlvalue: function () {
            if (this.modelurl)
                return utils.evaluate(this.modelurl, this);
            else
                return '';
        },
        modelrawvalue: function () {
            if (this.modelvalue)
                return utils.evaluateObject(this.modelvalue, this);
            else
                return [];
        },

        Rows: function () {
            return []; // this.modelfunc;
        },
        SelectedRows: function () {
            return this.selected_rows;
        },
        SelectedRowsAsArray: function () {
            return this.selectedRowsData;
        },
        HasSelectedRows: function () {
            return false;
        },
        GridColumns: function () {
            return this.columnDefs;
        },

        agColumnDefs: function () {
            // init_columns_visible is not reactive, so this dependency is what makes the remount after Restore default
            // settings get column defs built from the reset visibility instead of the cached ones
            this.columnDefsVersion;

            //return [
            //    {
            //        field: 'PhoneNumber',
            //    }
            //];

            let coldefs;
            if (this.columnDefs && this.columnDefs.length > 0) {
                coldefs = [];

                for (let i = 0; i < this.columnDefs.length; i++) {
                    const cd = this.columnDefs[i];
                    let sortComparitor = this.colSortComparator; // this.numberSortComparator;

                    // Use non-reactive cache to avoid mutating reactive columnDefs items inside a computed
                    if (!this.static_vars.colFuncCache[i]) this.static_vars.colFuncCache[i] = {};
                    const cc = this.static_vars.colFuncCache[i];

                    if (!cc.visibleexpr && cd.Visible && typeof cd.Visible === 'string') {
                        cc.visibleexpr = utils.compileObject(this, cd.Visible);
                    }

                    if (cd.CellClassExpression && !cc.cellclassexpr)
                        cc.cellclassexpr = utils.compileExpression(this, cd.CellClassExpression);

                    let cssClass;
                    if (cc.cellclassexpr)
                        cssClass = ({ node }) => {
                            this.static_vars.rowDataTemp = node.data;
                            this.static_vars.rowIndex = typeof node.rowIndex === 'number' ? node.rowIndex : -1;
                            return utils.evaluate(cc.cellclassexpr, this);
                        }

                    let calcCellValue;
                    let exportCellValue;

                    if (cd.SortAndFilterTemplate) {
                        if (!cc.sortandfilterfunc)
                            cc.sortandfilterfunc = utils.compile(this, cd.SortAndFilterTemplate);

                        if (cd.SortAndFilterTemplate.includes('{#') || cd.SortAndFilterTemplate.includes('{%'))
                            sortComparitor = this.numberSortComparator;

                        calcCellValue = (node) => {
                            this.static_vars.rowDataTemp = node.data;
                            this.static_vars.rowIndex = (node.node != null && typeof node.node.rowIndex === 'number') ? node.node.rowIndex : -1;
                            return utils.evaluate(cc.sortandfilterfunc, this);
                        };
                    }

                    if (cd.ExportTemplate) {
                        if (!cc.exportfunc)
                            cc.exportfunc = utils.compile(this, cd.ExportTemplate);

                        // if there is an export template, update the calcCellValue to use the exportfunc rather than the sortandfilter func (which is used by default if no ExportTemplate is provided)
                        calcCellValue = (node) => {
                            this.static_vars.rowDataTemp = node.data;
                            this.static_vars.rowIndex = (node.node != null && typeof node.node.rowIndex === 'number') ? node.node.rowIndex : -1;
                            return utils.evaluate(cc.exportfunc, this);
                        };
                    }

                    if (!cc.getQuickFilterText) {
                        cc.getQuickFilterText = params => {
                            if (this.controlData.SearchOnlyVisibleColumns && (params.colDef.hide || !params.value))
                                return '';

                            if (cc.sortandfilterfunc) {
                                this.static_vars.rowDataTemp = params.data;
                                this.static_vars.rowIndex = (params.node != null && typeof params.node.rowIndex === 'number') ? params.node.rowIndex : -1;
                                return utils.evaluate(cc.sortandfilterfunc, this);
                            }
                            else
                                return params.value?.toString();
                        };
                    }

                    let cdef;

                    if (cd.ContentDefs && cd.ContentDefs.length > 0) {
                        // This code is used when the grid cell has a ContentDefs array defined, which
                        // will insert custom controls into the grid cell using this template named here:
                        // (the template gets its definition above and generates a content-def component)

                        let dataType;
                        if (cd.CellFilter) {
                            const parts = cd.CellFilter.split(':');
                            if (parts[0] == 'number')
                                dataType = 'number';
                            else if (parts[0].includes('date'))
                                dataType = 'date';
                            else if (parts[0].includes('time'))
                                dataType = 'datetime';
                        }

                        cdef = {
                            headerName: cd.ActionOnlyColumn ? '' : (this.Translate(cd.DisplayName || cd.Name || cd.Field)),
                            field: cd.ActionOnlyColumn ? '' : (cd.Field || cd.Name),
                            colId: cd.Name || cd.Field,
                            sortable: cd.Sortable && !cd.ActionOnlyColumn,
                            filter: true && !cd.ActionOnlyColumn,
                            resizable: true,
                            comparator: sortComparitor,
                            // Use initialHide (not hide) so refreshing/reapplying columnDefs does not
                            // overwrite visibility the user changed via the grid menu or column API.
                            initialHide: !this.init_columns_visible[i],
                            getQuickFilterText: cc.getQuickFilterText || undefined,

                            suppressHeaderFilterButton: this.type == 'InfiniteGrid',
                            suppressHeaderMenuButton: this.type == 'InfiniteGrid',
                          //suppressHeaderFilterButton: this.type == 'InfiniteGrid',

                            mainMenuItems: ['pinSubMenu', 'separator', 'sortAscending', 'sortDescending', 'sortUnSort', 'separator', 'autoSizeThis', 'autoSizeAll', 'separator', 'resetColumns'],

                            valueGetter: calcCellValue,
                            valueFormatter: null,
                            autoHeight: cd.AutoHeight,
                            cellRenderer: 'AgContentDef',
                            cellRendererParams: {
                                callcorp: {
                                    root: this.root,
                                    contentDefs: cd.ContentDefs,
                                    addrowdata: this.addrowdata,
                                    scopeitems: this.scopeitems,
                                    controlscope: this.controlscope,
                                    field: cd.Field || cd.Name,
                                    context: this,
                                    loading: i == 0, // mark column as the loading column
                                    asyncPending: this.asyncPending,
                                    asyncDone: this.asyncDone,
                                }
                            },
                        };
                    }
                    else {
                        // This code is used when the grid cell does not have a ContentDefs array, so 
                        // the contents are automatically generated as the value of the record
                        let dataType;
                        if (cd.CellFilter) {
                            const parts = cd.CellFilter.split(':');
                            if (parts[0] == 'number')
                                dataType = 'number';
                            else if (parts[0].includes('date'))
                                dataType = 'date';
                            else if (parts[0].includes('time'))
                                dataType = 'datetime';
                        }

                        if (cd.CellFilter && !cc.cellFilterFunc) {
                            // Take ex: date:'medium'
                            // Generate function as:
                            // return context.f_date(data.field, 'medium')  -- context === this
                            const parts = cd.CellFilter.split(':');
                            const code = `return context.f_${parts[0]}(data.${cd.Field},${parts[1]});`;
                            const func = new Function('context', 'data', code);
                            cc.cellFilterFunc = (node) => {
                                if (node.data) {
                                    try { return func(this, node.data); } catch (e) {
                                        utils.warn(`Grid cell failed to evaluate ${code}`, e); return '';
                                    }
                                } else {
                                    return '';
                                }
                            };
                        }
                        else if (!cd.CellFilter && !cd.CellFilterFunc && !cc.cellFilterFunc) {
                            let nullchecks = '';
                            if (cd.Field && cd.Field.includes('.')) {
                                const parts = cd.Field.split('.');
                                for (let i = 0; i < parts.length - 1; i++)
                                    nullchecks += (nullchecks ? ' && ' : '') + `data.${parts[i]}`;
                                nullchecks += ` ? (!!value!!) : ''`;
                            }
                            let code = `typeof data.${cd.Field} === 'object' ? JSON.stringify(data.${cd.Field}) : data.${cd.Field}`;

                            if (nullchecks)
                                code = nullchecks.replace('!!value!!', code);

                            code = 'return ' + code + ';';
                            const func = new Function('data', code);
                            cc.cellFilterFunc = (node) => {
                                if (node.data) {
                                    try { return func(node.data); } catch (e) {
                                        utils.warn(`Grid cell failed to evaluate ${code}`, e); return '';
                                    }
                                } else {
                                    return '';
                                }
                            };
                        }

                        if (this.type == 'BasicGrid' && !calcCellValue) {
                            // This affects the sorting when using a BasicGrid, but the InfiniteGrid lets the server
                            // do the sorting, so this isn't necessary and it causes problems in the logic that tells
                            // the server what column we are sorting on. So we have to skip this for the InfiniteGrid.
                            const code = `return typeof data.${cd.Field} === 'object' ? JSON.stringify(data.${cd.Field}) : data.${cd.Field};`;
                            const func = new Function('data', code);
                            calcCellValue = (node) => {
                                try { return func(node.data); } catch (e) {
                                    utils.warn(`Grid cell failed to evaluate ${code}`, e); return '';
                                }
                            };
                        }

                        cdef = {
                            headerName: this.Translate(cd.DisplayName || cd.Name || cd.Field),
                            field: cd.Field || cd.Name,
                            colId: cd.Name || cd.Field,
                            sortable: cd.Sortable,
                            filter: true,
                            resizable: true,
                            comparator: sortComparitor,
                            autoHeight: cd.AutoHeight,
                            // Use initialHide (not hide) so refreshing/reapplying columnDefs does not
                            // overwrite visibility the user changed via the grid menu or column API.
                            initialHide: !this.init_columns_visible[i],
                            getQuickFilterText: cc.getQuickFilterText || undefined,

                            suppressHeaderFilterButton: this.type == 'InfiniteGrid',
                            suppressHeaderMenuButton: this.type == 'InfiniteGrid',
                          //suppressHeaderFilterButton: this.type == 'InfiniteGrid',
                            mainMenuItems: ['pinSubMenu', 'separator', 'sortAscending', 'sortDescending', 'sortUnSort', 'separator', 'autoSizeThis', 'autoSizeAll', 'separator', 'resetColumns'],
                        };
                        if (calcCellValue)
                            cdef.valueGetter = calcCellValue;

                        if (cc.cellFilterFunc)
                            cdef.valueFormatter = cc.cellFilterFunc;
                    }

                    if (cssClass)
                        cdef.cellClass = cssClass;
                    
                    cdef.cellStyle = { display: 'flex', flex: 1, overflow: 'hidden', whiteSpace: 'nowrap' };

                    switch (cd.Align) {
                        case 'Right':
                            cdef.headerClass = 'rightAligned';
                            cdef.cellStyle.textAlign = 'right';
                            cdef.cellStyle.justifyContent = 'flex-end';
                            break;
                        case 'Center':
                            cdef.headerClass = "centerAligned"; 
                            cdef.cellStyle.textAlign = 'center';
                            cdef.cellStyle.justifyContent = 'center';
                            break;
                    }

                    if (this.type == 'InfiniteGrid')
                        cdef.suppressHeaderMenuButton = true;

                    // Honor ColumnDef.Width: 'Auto' (default), 'SizeToContent' (autosize on first render),
                    // or a pixel size ('250', '250px'). Matches FastGrid / schema description.
                    if (cd.Width && cd.Width !== 'Auto' && cd.Width !== 'SizeToContent') {
                        const w = parseInt(cd.Width, 10);
                        if (!isNaN(w) && w > 0)
                            cdef.width = w;
                    }

                    if (cd.AutoHeight) {
                        cdef.wrapText = true;
                        if (cdef.cellStyle) {
                            cdef.cellStyle.whiteSpace = 'normal';
                            cdef.cellStyle.alignItems = 'flex-start';
                        }
                    }

                    coldefs.push(cdef);
                }
            }
            return coldefs;
        },

        totalItems() {
            let count = this.controlData.GridHeaderControls ? this.controlData.GridHeaderControls.length : 0;

            if (this.controlData.LeftGridHeaderControls)
                count += this.controlData.LeftGridHeaderControls.length;

            return count + 1;
        },

        todoPercent() {
            const c1 = Number(this.addrowdata_count);
            const c2 = Number(this.addrowdata_todo);
            if (!c1 || c1 <= 0)
                return 0;
            return (c1 - c2) / c1;
            //return 100.0 * ((Number(this.addrowdata_count) - Number(this.addrowdata_todo)) / Number(this.addrowdata_count));
        },
        todoValues() {
            return `(${this.addrowdata_count} - ${this.addrowdata_todo}) / ${this.addrowdata_count}`;
        },
    },
    methods: {
        preRenderComplete() {
            //this.finishRenderHandler(this);
        },

        async postRenderComplete() {
            console.log('BaseAgGridMixin postRenderComplete');

            await this.LoadSchema();
            await this.Refresh(false);
        },
        async performGridReset(clearSelectedRows) {
            if (clearSelectedRows)
                this.ClearSelectedRows();

            if (this.gridApi)
                this.gridApi.onSortChanged();
        },

        async performGridRefresh(action) {
            utils.log(`${this.type} ${this.name} GridRefresh`);

            if (action.ActionData.Debug && action.ActionData.Debug.BreakPoint) debugger;

            try {
                await this.Refresh(action.ActionData.ClearSelectedRows);
                
                if (this.controlData.RefreshActions)
                    await utils.executeAndCompileAllActions(this.controlData.RefreshActions, null, this);

                try {
                    await utils.success(action);
                } catch (e) { }
            }
            catch (e) {
                try {
                    await utils.failure(action);
                } catch (e) { }
            }
            finally {
                try {
                    await utils.complete(action);
                }
                catch (e) { }

                // Complete the promise for the executeAction method
                action.FinishFunc(true);
            }
        },
        isRowSelectable(rowNode) {
            if (this.controlData.SelectOptions.Enable) {
                if (this.selectableexpn) {
                    // dynamic decision
                    return utils.evaluate(this.selectableexpn, this, false, null, false, rowNode.data);
                } else {
                    // no expression but we are enabled.
                    return true;
                }
            } else {
                // we are not enabled.
                return false;
            }
        },
        getGroupingOption(field, compiled_expn, defaultValue) {
            if (!this.controlData.GroupingOptions) return defaultValue;

            if (compiled_expn && this.controlData.GroupingOptions[compiled_expn]) {
                const expn = this.controlData.GroupingOptions[compiled_expn];
                const ret = utils.evaluate(expn, this, false, false, false, null, null);
                return ret ? ret : defaultValue;
            }

            const value = this.controlData.GroupingOptions[field];
            return value ? value : defaultValue;
        },
        getRowSelectionConfig() {
            if (!this.controlData.SelectOptions.Enable) {
                return undefined;
            }

            const mode = this.controlData.SelectOptions.MultiSelect ? 'multiRow' : 'singleRow';
            const config = {
                mode,
                isRowSelectable: this.isRowSelectable,
                enableClickSelection: false,
            };

            if (mode === 'multiRow') {
                const groupSelectsChildren = this.getGroupingOption('SelectChildren', null, false);
                if (groupSelectsChildren) {
                    config.groupSelects = 'descendants';
                }

                // Vue2: headerCheckboxSelection: !serverSide || ForceHeaderCheckbox
                config.headerCheckbox =
                    !this.isServerSideModel() || !!this.controlData.SelectOptions?.ForceHeaderCheckbox;

                // Vue2 used headerCheckboxSelectionFilteredOnly. AG Grid 34 uses selectAll;
                // 'filtered' is client-side only (error 102 for serverSide/infinite).
                if (!this.isServerSideModel() && this.type !== 'InfiniteGrid') {
                    config.selectAll = 'filtered';
                }
            }

            return config;
        },
        async performGridClearSelectedRows(action) {
            utils.log(`${this.type} ${this.name} GridClearSelectedRows`);

            if (action.ActionData.Debug && action.ActionData.Debug.BreakPoint) debugger;

            try {
                this.ClearSelectedRows();

                try {
                    await utils.success(action);
                } catch (e) { }
            }
            catch (e) {
                try {
                    await utils.failure(action);
                } catch (e) { }
            }
            finally {
                try {
                    await utils.complete(action);
                }
                catch (e) { }

                // Complete the promise for the executeAction method
                action.FinishFunc(true);
            }
        },
        async LoadSchema() {
            if (this.schemaurl)
                try {
                    this.schema = await utils.schema.get(this.schemaurlvalue);
                }
                catch (e) {
                    utils.warn('BasicGrid schemaurl ' + this.controlData.SchemaURL + ' failed to retrieve: ' + e);
                    this.schema = null;
                }
        },
        async internalRefresh(clearSelectedRows) {
            console.log('BaseAgGridMixin internalRefresh');
            let previouslySelected = [];
            if (this.controlData.RetainSelectedOnRefresh) {
                // Retain selected rows
                if (this.gridApi) {
                    previouslySelected = this.gridApi.getSelectedRows();
                }
            }

            if (clearSelectedRows)
                this.ClearSelectedRows();

            //this.modelfunc = null;

            let model;
            if (this.controlData.DataType === 'URL' && this.modelurl) {
                try {
                    model = this.modelurlvalue ? await utils.api.get(this.modelurlvalue, false, false) : [];
                }
                catch (e) {

                    // SignalR backwards compatability
                    var statusCode = e.StatusCode ? e.StatusCode : e.statusCode;
                    var reasonPhrase = e.ReasonPhrase ? e.ReasonPhrase : e.reasonPhrase;

                    let msg = `Failed in API call to ${this.modelurlvalue}`;
                    utils.warn(`${this.type} ${this.name} ${msg}`, e);
                    msg = `API call failed: ${reasonPhrase}`;
                    EventBus.$emit('v-toast', {
                        text: 'Error',
                        subtext: e ? msg : 'Unknown error',
                        type: 'error',
                        icon: 'mdi mdi-alert',
                        ontap: [
                            {
                                "PrimitiveAction": true,
                                "ActionType": "DisplayConfirmModal",
                                "RunAsync": false,
                                "ActionData": {
                                    "OkayButtonText": "Okay",
                                    "CancelButtonText": "Cancel",
                                    "Debug": {},
                                    "Title": "Error " + (e ? statusCode : ''),
                                    "Message": `Failed in API call to ${this.modelurlvalue} - ${reasonPhrase}`
                                }
                            }
                        ],
                        context: this,
                    });
                }

                if (!this.modelurl_watch$)
                    this.modelurl_watch$ = this.$watch(
                        function () {
                            return this.modelurlvalue;
                        },
                        function (val, oldval) {
                            utils.debug(`BasicGridMixin ${this.name} URL value changed to: ${val}`);
                            this.Refresh();
                        }
                    );
            }
            else if (this.controlData.DataType == 'Raw' && this.modelvalue)
                try {
                    model = this.modelrawvalue;
                    
                    if (!this.modelvalue_watch$)
                        this.modelvalue_watch$ = this.$watch(
                            function () {
                                try {
                                    return this.modelrawvalue;
                                }
                                catch (e) {
                                    utils.warn('Full BasicGrid modelvalue ' + this.controlData.Model.Definition + ' failed to evaluate: ' + e);
                                    return null;
                                }
                            },
                            function (val, oldval) {
                                this.Refresh();
                            },
                            {
                                deep: false
                            }
                        );
                }
                catch (e) {
                    utils.warn('BasicGrid modelvalue ' + this.controlData.Data + ' failed to evaluate: ' + e);
                    model = [];
                }
            else
                model = [];

            this.modelfunc = markRaw( model );

            if (this.addrowdata && this.addrowdata.length && Array.isArray(model)) {
                const asyncRows = this.countRowsWithAsyncLookup(model);
                this.addrowdata_count = asyncRows;
                this.addrowdata_todo = asyncRows;
            }

            //if (this.gridApi)
            //    this.gridApi.refreshCells();
            // Row refresh / columnDefs reapplication can wipe user column visibility;
            // re-apply from the menu / localStorage-backed columns_visible flags.
            this.$nextTick(() => {
                this.applyPersistedColumnVisibility();

                if (this.controlData.RetainSelectedOnRefresh && previouslySelected.length > 0) {
                    this.SetSelectedRows(previouslySelected, true);
                }
            });

            //setTimeout(() => this.resolveAllAdditionalRowData(), 1000);
        },

        RefreshClicked() {
            if (this.controlData.HeaderOptions?.RefreshIconActions && this.controlData.HeaderOptions?.RefreshIconActions.length > 0) {
                    utils.executeAndCompileAllActions(this.controlData.HeaderOptions.RefreshIconActions, null, this);
            } else if (this.controlData.DataType === 'Raw') {
                utils.executeAndCompileAllActions([
                    {
                        "PrimitiveAction": true,
                        "ActionType": "Refresh",
                        "RunAsync": false,
                        "ActionData": {
                            "Debug": {
                                "BreakPoint": false
                            }
                        },
                    }
                ], {}, this);
            } else {
                this.Refresh();
            }

        },
        RefreshCells() {
            this.gridApi.refreshCells();
        },
        ClearSelectedRows() {
            utils.debug(`${this.type} ${this.name} ClearSelectedRows()`);

            this.selected_rows = {};
            this.selectedRowsData = [];
            this.gridApi?.deselectAll();
        },
        SetSelectedRows(selectedArray, shouldClearSelection) {
            utils.debug(`BasicGrid ${this.name}.SetSelectedRows(${JSON.stringify(selectedArray)})`);

            // selectedArray is an array containing objects with the KeyFields - ex: KeyFields:['ID','Name']
            // then selectedArray might be [{'ID':'1', 'Name':'James'}, {'ID':'2', 'Name': 'Sam'}]

            // Therefore, to update the grid properly, we have to locate each row by key and update the selected_rows and selectedRowsData:

            const to_select_rows = [];
            const to_select_keys = {};

            const keys = this.controlData.KeyFields;
            const to_find = [...selectedArray];

            this.gridApi.deselectAll();
            this.gridApi.forEachNode(node => {
                // Set if this should be selected
                // const idx = to_find.findIndex(key => Object.keys(key).every(k => node.data[k] == key[k]));
                const idx = to_find.findIndex(item => keys.every(k => node.data[k] == item[k])); // Changed so it only compares the keys as defined above (KeyFields) - 3/12/25 DP
                                                                                                 // Allows an existing row or rows to be passed in as the selectedArray. Needed in FastGrid serverRowModel refresh.
                const isSelected = idx >= 0;
                node.setSelected(isSelected);
                if (isSelected) {
                    // Remove the found item from the to_find array to reduce how many items we have to skip over
                    to_find.splice(idx, 1);
                    // Save the row data in the selected rows array
                    to_select_rows.push(node.data);
                    // Build the row key and save in the selected keys object
                    const str_key = keys.map(k => `_${node.data[k]}`).join('');
                    to_select_keys[str_key] = node.data;
                }
            });

            if (shouldClearSelection) {
                this.selected_rows = to_select_keys;
                this.selectedRowsData = to_select_rows;
            }
            else {
                Object.keys(to_select_keys).forEach(key => this.selected_rows[key] = to_select_keys[key]);
                to_select_rows.forEach(item => this.selectedRowsData.push(item));
            }
        },
        SizeColumnsToContent() {
            this.gridApi.autoSizeAllColumns();
        },

        async SetColumnFilter(field, filter) {
            await this.gridApi.setColumnFilterModel(field, filter);
            this.gridApi.onFilterChanged();
        },
        ResetAllColumnFilters() {
            this.gridApi.setFilterModel(null);
            this.gridApi.onFilterChanged();
        },

        NotifyDataChange() {

        },
        async ExportData(all) {
            await this.resolveAllAdditionalRowData();
            await this.waitForAdditionalRowDataAsyncIdle();

            this.gridApi.exportDataAsCsv({ allColumns: all, processCellCallback: this.processCellCallback });
        },
        processCellCallback(params){
            try{
                if(this.allowExportAll){
                    // Export bypasses the value formatters, so the DateTime.MinValue sentinel would
                    // reach the file as a literal 0001 date even though the cell renders empty.
                    // Only the exact sentinel spellings are matched, so text columns are untouched.
                    if(params.value === '0001-01-01T00:00:00' || params.value === '0001-01-01T00:00:00Z' || params.value === -62135596800000)
                        return "";
                    return params.value;
                }
                else if(params.column.colDef?.cellRendererParams?.callcorp && params.column.colDef.field && params.node.data.exportValues && params.node.data.exportValues[params.column.colDef.field]){
                    return params.node.data.exportValues[params.column.colDef.field]?.join(' ') || "";
                }
                else return "";
            }catch(err){
                debugger;
            }
        },

        columnFilterChanged(e) {
            if (!this.gridApi) return;
            
            var filterModel = this.gridApi.getFilterModel();

            if (this.useLocalStorage) {
                this.System.LocalStorage(this.storageKey + '-column_filters', JSON.stringify(filterModel));
            }

            this.HasFilters = filterModel ? Object.keys(filterModel).length > 0 : false;
        },

        colSortComparator(valueA, valueB) {
            // Enable case insensitive sort
            if (typeof valueA === 'string' && typeof valueB === 'string')
                return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
            else if (typeof valueA === 'integer' && typeof valueB === 'integer')
                return valueA - valueB;
            else if (typeof valueA === 'number' && typeof valueB === 'number')
                return valueA - valueB;
            else
                return 0;
        },
        numberSortComparator(num1, num2) {
            // Enable nmerical sort
            return num1 - num2;
        },
        toggleScrollMode(e) {
            if (this.scrollMode == 'virtual')
                this.scrollMode = 'standard';
            else
                this.scrollMode = 'virtual';
        },
        toggleColumnVisible(field, index) {
            const newValue = !this.columns_visible[index];

            // This directly alters the visibility
            this.gridApi.setColumnsVisible([field], newValue);

            // The checkboxes in the grid menu are bound to this
            this.columns_visible[index] = newValue;
            // Keep the def-generation copy in sync so a later columnDefs rebuild
            // (or AgGrid remount) starts from the user's current visibility.
            if (this.init_columns_visible)
                this.init_columns_visible[index] = newValue;

            if (this.useLocalStorage) {
                this.System.LocalStorage(this.storageKey + '-columns_visible', JSON.stringify(this.columns_visible));
            }
        },
        setColumnVisible(field, index, value, override) {
            // This directly alters the visibility
            
            if (this.gridApi) {
                this.gridApi.setColumnsVisible([field], value);
                if(override)
                    this.init_columns_visible[index] = value;
            }
            else {
                this.init_columns_visible[index] = value;
                this.columns_visible[index] = value;
            }
            
        },
        togglePagination() {
            this.pagination = !this.pagination;

            if (this.useLocalStorage) {
                this.System.LocalStorage(this.storageKey + '-standard_pagination', this.pagination ? 'true' : 'false');
            }

            this.unique_id = utils.generateUUID();
        },

        getRowClass(params) {
            if (this.controlData.RowClassExpression)
            {
                if (!this.rowClassExpr)
                    this.rowClassExpr = utils.compileExpression(this, this.controlData.RowClassExpression, 'row');

                //set row data and index for interpolation to work.
                this.static_vars.rowDataTemp = params.data;
                this.static_vars.rowIndex = (typeof params.rowIndex === 'number')
                    ? params.rowIndex
                    : (params.node != null && typeof params.node.rowIndex === 'number' ? params.node.rowIndex : -1);

                try {
                    return utils.evaluate(this.rowClassExpr, this, false, false, false, params.data);
                }
                catch (e)
                {
                    utils.warn('Grid RowClassExpression ' + this.controlData.RowClassExpression + ' failed to evaluate: ' + e);
                    return '';
                }
            }
        },

        getGridMenuColumnList(h, menus) {
            for (let i = 0; i < this.columnDefs.length; i++) {
                const col = this.columnDefs[i];
                if (col.ActionOnlyColumn) continue;

                menus.push(
                    <QItem key={i + 4} clickable onClick={() => this.toggleColumnVisible(col.Name || col.Field, i)}>
                        <QItemSection avatar>
                            {this.columns_visible[i] ? <QIcon name="mdi-check" size="sm" /> : null}
                        </QItemSection>
                        <QItemSection>
                            <QItemLabel><TranslationContainer context={this} value={col.DisplayName || col.Name || col.Field} /></QItemLabel>
                        </QItemSection>
                    </QItem>
                );
            }
        },

        refreshDataGrid() {
            this.Refresh(false);
        },

        /**
         * Legacy hook: additional-row progress is row-based (see resolveAllAdditionalRowData).
         * Kept for callers that still invoke asyncPending; no longer used by AgContentDef.
         */
        asyncPending(n) {
            const k = Number(n);
            if (!k || k < 1)
                return;
            this.addrowdata_count += k;
            this.addrowdata_todo += k;
        },
        asyncDone(args) {
            if (this.addrowdata_todo > 0)
                this.addrowdata_todo--;
        },
        /** True if AdditionalRowData schema includes at least one AsyncLookup for this row (displayexpr passes). */
        rowQualifiesForAsyncLookup(rowIndex, row) {
            if (!this.addrowdata || !this.addrowdata.length || row == null)
                return false;
            this.static_vars.rowDataTemp = row;
            this.static_vars.rowIndex = rowIndex;
            try {
                for (let j = 0; j < this.addrowdata.length; j++) {
                    const add = this.addrowdata[j];
                    for (let i = 0; i < add.contentDefs.length; i++) {
                        const c = add.contentDefs[i];
                        if (c.displayexpr && !utils.evaluate(c.displayexpr, this))
                            continue;
                        if (c.type === 'AsyncLookup')
                            return true;
                    }
                }
                return false;
            }
            finally {
                this.static_vars.rowDataTemp = null;
                this.static_vars.rowIndex = -1;
            }
        },
        countRowsWithAsyncLookup(model) {
            if (!model || !model.length)
                return 0;
            let n = 0;
            for (let i = 0; i < model.length; i++) {
                if (this.rowQualifiesForAsyncLookup(i, model[i]))
                    n++;
            }
            return n;
        },
        /** Wait until cell-driven AdditionalRowData async completes (best effort for export). */
        async waitForAdditionalRowDataAsyncIdle(timeoutMs = 120000) {
            const start = Date.now();
            while (this.addrowdata_todo > 0 && (Date.now() - start < timeoutMs)) {
                await new Promise(function (resolve) { setTimeout(resolve, 40); });
            }
            if (this.addrowdata_todo > 0)
                utils.warn(`${this.type} ${this.name} timed out waiting for AdditionalRowData async (${this.addrowdata_todo} ops remaining)`);
        },
        async resolveAllAdditionalRowData() {
            if (!this.addrowdata || !this.addrowdata.length)
                return;

            if (this.addrowdata_inprogress) {
                let resolver;
                const promise = new Promise(function (resolve, reject) { resolver = resolve; });
                this.addrowdata_promises.push(resolver);
                await promise;
                return;
            }

            try {
                this.addrowdata_inprogress = true;
                this.addrowdata_promises = [];

                const model = this.modelfunc;
                if (!model || !model.length)
                    return;

                const todo = [];
                for (let i = 0; i < model.length; i++) {
                    const row = model[i];
                    if (!('$$additional_row_data' in row))
                        todo.push(row);
                }

                if (todo.length < 1)
                    return;

                const promises = [];
                for (let i = 0; i < todo.length; i++) {
                    promises.push(this.resolveAdditionalRowData(i, todo[i]));
                }

                await Promise.all(promises);
            }
            finally {
                this.addrowdata_inprogress = false;

                if (this.addrowdata_promises.length)
                    this.addrowdata_promises.forEach(r => r());
            }
        },
        async resolveAdditionalRowData(rowIndex, row) {
            this.static_vars.rowDataTemp = row;
            this.static_vars.rowIndex = rowIndex;
            let rowHadAsyncLookup = false;
            try {
                if (this.addrowdata && !('$$additional_row_data' in row)) {
                    row['$$additional_row_data'] = {};

                    for (let j = 0; j < this.addrowdata.length; j++) {
                        const add = this.addrowdata[j];
                        if (add.initValue) {
                            row.$$additional_row_data[add.name] = utils.evaluateObject(add.initValue, this);
                        }

                        for (let i = 0; i < add.contentDefs.length; i++) {
                            const c = add.contentDefs[i];
                            if (c.displayexpr && !utils.evaluate(c.displayexpr, this))
                                continue;

                            this.static_vars.rowIndex = rowIndex;
                            this.static_vars.rowDataTemp = row;

                            switch (c.type) {
                                case 'RawInterpolated':
                                    row.$$additional_row_data[add.name] = utils.evaluateObject(c.valueexpr, this);
                                    break;

                                case 'AsyncLookup':
                                    rowHadAsyncLookup = true;
                                    row.$$additional_row_data[add.name] = {};
                                    try {
                                        const url = utils.evaluate(c.urlexpr, this);
                                        const res = await utils.api.get(url, false, c.cache);
                                        this.Input = { Data: res };
                                        row.$$additional_row_data[add.name] = utils.evaluateObject(c.valueexpr, this);
                                    }
                                    catch (lookupErr) {
                                        utils.warn(`${this.type} ${this.name} AsyncLookup AdditionalRowData[${rowIndex}] ${add.name}`, lookupErr);
                                    }
                                    break;
                            }
                        }
                    }
                }
            }
            catch (e) {
                utils.warn(`${this.type} ${this.name} AdditionalRowData[${rowIndex}] error`, e);
            }
            finally {
                if (rowHadAsyncLookup)
                    this.asyncDone({});
                this.static_vars.rowDataTemp = null;
                this.static_vars.rowIndex = -1;
            }
        },
        getAdditionalRowData(name) {
            if (this.static_vars.rowDataTemp && ('$$additional_row_data' in this.static_vars.rowDataTemp))
                return name ? this.static_vars.rowDataTemp.$$additional_row_data[name] : this.static_vars.rowDataTemp.$$additional_row_data;
            else
                return {};
        },

        getGridHeaders() {
            const items = [];

            if (this.controlData.EnableFilter) {
                items.push(
                    <QInput
                        key="quicksearch"
                        class="q-mb-none quick-search-input"
                        dense
                        hide-hint
                        hide-bottom-space
                        clearable
                        placeholder={this.Translate("Quick Search")}
                        modelValue={this.searchText}
                        onUpdate:modelValue={(v) => this.searchText = v}
                        v-slots={{ prepend: () => <QIcon name="mdi-magnify" /> }}
                    />
                );
            }
            else if (this.controlData.ShowJumpto) {
                items.push(
                    <QInput
                        key="jumpto"
                        style="max-width: 300px;"
                        class="q-mb-none"
                        dense
                        hide-hint
                        hide-bottom-space
                        clearable
                        placeholder="Jump to..."
                        modelValue={this.jumpToValue}
                        onUpdate:modelValue={(v) => {
                            this.jumpToValue = v || "";
                            this.performGridReset(true);
                        }}
                        v-slots={{ prepend: () => <QIcon name="mdi-arrow-right-bold"><QTooltip>{this.Translate('Jump to moves the list to the closest match in the currently sorted column. It does not hide rows that do not match. Date and time columns must be entered in a specific format (example: 2000-01-31T17:28:24.906Z); the full date is not required, and just the year, or the year and month, is supported.')}</QTooltip></QIcon> }}
                    />
                );
            }

            this.getLeftGridHeaderControls(items);

            // Separator to push remaining items to right
            items.push(<span style="flex-grow: 1;"></span>);

            if (this.addrowdata_todo)
                items.push(
                    <QLinearProgress
                        key="addrowdata-progress"
                        style="max-width: 100px;"
                        value={this.todoPercent}
                    />
                );
            //else
            //    items.push([
            //        <div class="q-mr-sm">{this.todoPercent} todo</div>,
            //        <div class="q-mr-sm">{this.todoValues} todo</div>,
            //    ]);

            if (this.selectedRowsData.length > 0)
                items.push(
                    <span key="selected-count">( {this.selectedRowsData.length} Selected
                        <QBtn flat dense size="sm" class="q-ml-sm" onClick={(e) => this.ClearSelectedRows()}>
                            <QIcon name="mdi-close-circle" />
                        </QBtn>)
                    </span>
                );

            this.getGridHeaderControls(items);

            if (!this.controlData.HideDefaultGridControls) {
                // Resizer (runs auto-resize for all columns)
                items.push(utils.generateTooltip(h,
                    <QBtn flat dense icon="mdi-arrow-left-right-bold" onClick={(e) => this.gridApi.autoSizeAllColumns()}>
                    </QBtn>, this.Translate('Size columns to content'), 'bottom'));

                // Resizer fit to screen (runs resize for all columns to fit all within screen width)
                items.push(utils.generateTooltip(h,
                    <QBtn flat dense icon="mdi-arrow-expand-horizontal" onClick={(e) => this.gridApi.sizeColumnsToFit()}>
                    </QBtn>, this.Translate('Size columns to fit'), 'bottom'));

                if (!this.controlData.HeaderOptions?.HideRefreshIcon) {
                    // Refresh
                    items.push(utils.generateTooltip(h,
                        <QBtn flat dense icon="mdi-cached" onClick={(e) => this.RefreshClicked()}>
                        </QBtn>, this.Translate('Refresh'), 'bottom'));
                }
            }

            if (!this.controlData.DisableGridMenu) {
                const menus = [];

                if (this.allowExportAll)
                    menus.push(
                        <QItem key={0} clickable onClick={(e) => { this.menu_is_open = false; this.ExportData(true); }}>
                            <QItemSection avatar><QIcon name="mdi-table-arrow-right" /></QItemSection>
                            <QItemSection>
                                <QItemLabel><TranslationContainer context={this} value="Export all columns as csv" /></QItemLabel>
                            </QItemSection>
                        </QItem>
                    );

                menus.push(
                    <QItem key={1} clickable onClick={(e) => { this.menu_is_open = false; this.ExportData(false); }}>
                        <QItemSection avatar><QIcon name="mdi-table-arrow-right" /></QItemSection>
                        <QItemSection>
                            <QItemLabel><TranslationContainer context={this} value="Export visible columns as csv" /></QItemLabel>
                        </QItemSection>
                    </QItem>
                );

                menus.push(
                    <QItem key={2} clickable onClick={(e) => this.RestoreDefaults(e)}>
                        <QItemSection avatar><QIcon name="mdi-file-undo" /></QItemSection>
                        <QItemSection>
                            <QItemLabel><TranslationContainer context={this} value="Restore default settings" /></QItemLabel>
                        </QItemSection>
                    </QItem>
                );

                menus.push(<QSeparator key="sep1" />);

                menus.push(
                    <QItem key={3} clickable onClick={() => { this.menu_is_open = false; this.togglePagination(); }}>
                        <QItemSection avatar>
                            {this.pagination ? <QIcon name="mdi-check" size="sm" /> : null}
                        </QItemSection>
                        <QItemSection>
                            <QItemLabel><TranslationContainer context={this} value="Use standard pagination" /></QItemLabel>
                        </QItemSection>
                    </QItem>
                );

                menus.push(<QSeparator key="sep2" />);

                // Add all columns with check boxes for visible
                this.getGridMenuColumnList(h, menus);

                // Menu: QMenu as direct child of trigger; it opens on trigger click. It does not auto-close, so the column
                // check boxes can be ticked in one go; the items that act set menu_is_open to false to close it.
                const menu = (
                    <QBtn key="grid-menu-trigger" flat dense icon="mdi-menu">
                        <QMenu
                            modelValue={this.menu_is_open}
                            onUpdate:modelValue={(v) => this.menu_is_open = v}
                            anchor="bottom end"
                            self="top end">
                            <QList dense style="max-height: 600px" class="overflow-y-auto">
                                {menus}
                            </QList>
                        </QMenu>
                    </QBtn>
                );

                items.push(menu);
            }

            return (
                <div class="gridHeaderButtons">
                    {items}
                </div>
            );
        },
        getGridHeaderControls(items) {
            if (this.controlData.GridHeaderControls && Array.isArray(this.controlData.GridHeaderControls) && this.controlData.GridHeaderControls.length > 0) {
                for (let i = 0; i < this.controlData.GridHeaderControls.length; i++) {
                    const c = this.controlData.GridHeaderControls[i];

                    let DynamicControl = utils.getDynamicComponent(h, c);

                    if (!DynamicControl)
                        DynamicControl = 'default-unknown';

                    items.push(
                        <DynamicControl
                            onFinishedRender={(reference) => this.finishRenderHandler(reference)}
                            type={c.ControlType}
                            name={c.ControlData.Name ? c.ControlData.Name : ''}
                            root={this.root}
                            parentType="HorizontalStack"
                            controlData={c.ControlData}
                            controlURL={c.ControlURL}
                            controlName={c.Name}
                            accessPermission={c.AccessPermission}
                            scopeitems={this.scopeitems}
                            controlscope={this.controlscope}
                            cacheControl={c.CacheControl}
                            controlEvents={c.Events}>
                        </DynamicControl>);
                }
            }
        },
        getLeftGridHeaderControls(items) {
            if (this.controlData.LeftGridHeaderControls && Array.isArray(this.controlData.LeftGridHeaderControls) && this.controlData.LeftGridHeaderControls.length > 0) {
                for (let i = 0; i < this.controlData.LeftGridHeaderControls.length; i++) {
                    const c = this.controlData.LeftGridHeaderControls[i];

                    let DynamicControl = utils.getDynamicComponent(h, c);

                    if (!DynamicControl)
                        DynamicControl = 'default-unknown';

                    items.push(
                        <DynamicControl
                            onFinishedRender={(reference) => this.finishRenderHandler(reference)}
                            type={c.ControlType}
                            name={c.ControlData.Name ? c.ControlData.Name : ''}
                            root={this.root}
                            parentType="HorizontalStack"
                            controlData={c.ControlData}
                            controlURL={c.ControlURL}
                            controlName={c.Name}
                            accessPermission={c.AccessPermission}
                            scopeitems={this.scopeitems}
                            controlscope={this.controlscope}
                            controlEvents={c.Events}
                        >
                        </DynamicControl>);
                }
            }
            // if (!this.controlData.DisableGridMenu)
        },

        RestoreDefaults() {
            this.menu_is_open = false;

            // Clear all persistent settings
            this.System.LocalStorage(this.storageKey + '-sort', null);
            this.System.LocalStorage(this.storageKey + '-state', null);
            this.System.LocalStorage(this.storageKey + '-columns_visible', null);
            this.System.LocalStorage(this.storageKey + '-standard_pagination', null);
            this.System.LocalStorage(this.storageKey + '-column_filters', null);
            this.System.LocalStorage(this.storageKey + '-expanded-groups', null);
            
            if (Array.isArray(this.columnDefs)) {
                this.columns_visible = this.columnDefs.map(d => !('Visible' in d) || d.Visible);
                this.init_columns_visible = [...this.columns_visible];
                this.columnDefsVersion++;
            }

            // Force reload
            this.unique_id = utils.generateUUID();
        },
        applyPersistedColumnVisibility() {
            if (!this.gridApi)
                return;

            // Prefer the full saved AG Grid column state (includes visibility, pin, width, order).
            if (this.useLocalStorage) {
                const statestr = this.System.LocalStorage(this.storageKey + '-state');
                const stateObj = statestr ? JSON.parse(statestr) : null;
                const columnState = this.getSavedColumnState(stateObj);

                if (columnState) {
                    this.gridApi.applyColumnState({ state: columnState, applyOrder: true });
                    if (stateObj.columnGroupState)
                        this.gridApi.setColumnGroupState(stateObj.columnGroupState);
                    this.syncColumnsVisibleFromGrid();
                    return;
                }
            }

            if (!Array.isArray(this.columnDefs) || !Array.isArray(this.columns_visible))
                return;

            for (let i = 0; i < this.columnDefs.length; i++) {
                const field = this.columnDefs[i].Name || this.columnDefs[i].Field;
                if (!field)
                    continue;

                const visible = !!this.columns_visible[i];
                this.gridApi.setColumnsVisible([field], visible);
                if (this.init_columns_visible)
                    this.init_columns_visible[i] = visible;
            }
        },
        // The Vue 2 and Vue 3 portals share one saved layout per grid, but ag-Grid names the checkbox column and the
        // unnamed columns differently in each. Here ag-Grid adds "ag-Grid-SelectionColumn" and the first unnamed column
        // is "0"; in Vue 2 our own checkbox column is "0" and the first unnamed column "1". Returns the saved column
        // state in this portal's ids, or null to keep the default layout (a layout scrambled by the other portal is removed).
        getSavedColumnState(stateObj) {
            if (!stateObj || !Array.isArray(stateObj.columnState))
                return null;

            const state = stateObj.columnState;
            const isIndex = (id) => /^\d+$/.test(id);

            try {
                // The ids only differ on a grid with checkboxes and an unnamed column; every other grid is used as saved
                const ids = (this.gridApi.getColumns() || []).map(c => c.getColId());
                if (this.controlData.EnableDynamicColumns || !this.controlData.SelectOptions || !this.controlData.SelectOptions.Enable
                    || !this.gridApi.getAllGridColumns().some(c => c.getColId() === 'ag-Grid-SelectionColumn') || !ids.some(id => isIndex(id)))
                    return state;

                let writer = stateObj.portal;
                if (!writer) {
                    // Saved before layouts were tagged: a clean one from either portal is recognized by its checkbox column
                    const hasSelectionColumn = state.some(c => c.colId === 'ag-Grid-SelectionColumn');
                    const first = state.find(c => c.colId === '0');

                    if (hasSelectionColumn && !state.some(c => isIndex(c.colId) && c.pinned === 'left'))
                        writer = 'vue3';
                    else if (!hasSelectionColumn && first && first.pinned === 'left')
                        writer = 'vue2';
                    else {
                        utils.warn(`Grid ${this.storageKey}: saved layout does not match this grid, using the default layout`);
                        this.System.LocalStorage(this.storageKey + '-state', null);
                        return null;
                    }
                }

                const result = writer === 'vue2'
                    ? state.map(c => {
                        if (c.colId === '0')
                            return Object.assign({}, c, { colId: 'ag-Grid-SelectionColumn', pinned: null });
                        if (isIndex(c.colId))
                            return Object.assign({}, c, { colId: String(Number(c.colId) - 1) });
                        return c;
                    })
                    : state.slice();

                // A column the layout does not name (added to the grid after it was saved) goes after its left-hand
                // neighbor in ColumnDefs order; ag-Grid would otherwise append it at the far right
                const order = ['ag-Grid-SelectionColumn', ...ids];
                for (let i = 0; i < order.length; i++) {
                    if (result.some(c => c.colId === order[i]))
                        continue;

                    let at = 0;
                    for (let j = i - 1; j >= 0; j--) {
                        const k = result.findIndex(c => c.colId === order[j]);
                        if (k >= 0) {
                            at = k + 1;
                            break;
                        }
                    }
                    result.splice(at, 0, { colId: order[i] });
                }

                return result;
            }
            catch (e) {
                utils.warn(`Grid ${this.storageKey}: saved layout could not be read, using the default layout`, e);
                return null;
            }
        },
        syncColumnsVisibleFromGrid() {
            if (!this.gridApi || !Array.isArray(this.columnDefs) || !Array.isArray(this.columns_visible))
                return;

            for (let i = 0; i < this.columnDefs.length; i++) {
                const field = this.columnDefs[i].Name || this.columnDefs[i].Field;
                if (!field)
                    continue;

                const col = this.gridApi.getColumn(field);
                if (!col)
                    continue;

                const visible = col.isVisible();
                this.columns_visible[i] = visible;
                if (this.init_columns_visible)
                    this.init_columns_visible[i] = visible;
            }

            if (this.useLocalStorage) {
                this.System.LocalStorage(this.storageKey + '-columns_visible', JSON.stringify(this.columns_visible));
            }
        },
        StartEditingRow(rowIndex, focusedCell) {
            this.gridApi.setFocusedCell(1, focusedCell);
            this.gridApi.startEditingCell({
                rowIndex: rowIndex,
                colKey: focusedCell,
            });
        },
        StopEditing() {
            this.gridApi.stopEditing();
        },

        detachGridScrollListener() {
            if (this.gridApi && this._onGridBodyScroll) {
                try {
                    this.gridApi.removeEventListener('bodyScroll', this._onGridBodyScroll);
                }
                catch (e) { /* grid may already be destroyed */ }
            }
        },
        captureGridScrollFromEvent(e) {
            // Ignore scroll events while the viewport has no layout (being hidden/detached).
            const viewport = this.$refs.agGridRef?.$el?.querySelector('.ag-body-viewport');
            if (viewport && viewport.clientHeight === 0)
                return;

            let firstRow = 0;
            try {
                if (this.gridApi?.getFirstDisplayedRowIndex)
                    firstRow = this.gridApi.getFirstDisplayedRowIndex() || 0;
            }
            catch (err) { /* ignore */ }

            this._savedGridScroll = {
                top: e?.top || 0,
                left: e?.left || 0,
                firstRow,
            };
        },
        captureGridScrollPosition() {
            if (!this.gridApi)
                return;

            try {
                const v = this.gridApi.getVerticalPixelRange?.();
                const h = this.gridApi.getHorizontalPixelRange?.();
                const firstRow = this.gridApi.getFirstDisplayedRowIndex?.() || 0;
                // If already detached, ranges are often 0 — keep prior bodyScroll capture.
                if ((v?.top || 0) === 0 && firstRow === 0 && (h?.left || 0) === 0)
                    return;

                this._savedGridScroll = {
                    top: v?.top || 0,
                    left: h?.left || 0,
                    firstRow,
                };
            }
            catch (e) { /* ignore */ }
        },
        restoreGridScrollPosition() {
            const saved = this._savedGridScroll;
            if (!saved || !this.gridApi)
                return;
            if (!saved.top && !saved.left && !saved.firstRow)
                return;

            const apply = () => {
                if (!this.gridApi)
                    return;
                try {
                    if (saved.firstRow > 0 && this.gridApi.ensureIndexVisible)
                        this.gridApi.ensureIndexVisible(saved.firstRow, 'top');

                    const root = this.$refs.agGridRef?.$el;
                    if (!root)
                        return;
                    const vertical = root.querySelector('.ag-body-viewport');
                    const horizontal = root.querySelector('.ag-body-horizontal-scroll-viewport');
                    if (vertical && saved.top)
                        vertical.scrollTop = saved.top;
                    if (horizontal && saved.left)
                        horizontal.scrollLeft = saved.left;
                }
                catch (e) { /* ignore */ }
            };

            apply();
            if (typeof requestAnimationFrame === 'function')
                requestAnimationFrame(apply);
        },
        onGridReady(params) {
            this.gridApi = params.api;

            if (this.controlData.EnableTimerWatch)
                this.watch_date_value$ = this.$watch(function () {
                    return utils.helpers.chf.date_value.value;
                }, function (newvalue) {
                    this.gridApi.refreshCells();
                });

            // Access the first child div of the component's root element to
            // add a class which will correct a bug when trying to include
            // ag-grid in a dialog. The inner div only has a height: 100%
            // which does not work in a dialog (not sure why). This adds
            // a class that sets display: flex, flex-grow: 1, etc. (2025-06-17 DP)
            const nestedDiv = this.$refs.agGridRef?.$el.children[0];
            if (nestedDiv && nestedDiv.tagName === 'DIV') {
                nestedDiv.classList.add('ag-grid-flex-layout');
            }

            params.api.addEventListener('bodyScroll', this._onGridBodyScroll);

            // v-show on the grid wrapper (isvisible) also zeros scroll without KeepAlive hooks.
            if (!this._isvisible_scroll$) {
                this._isvisible_scroll$ = this.$watch(
                    () => this.isvisible,
                    (visible, wasVisible) => {
                        if (visible && !wasVisible)
                            this.$nextTick(() => this.restoreGridScrollPosition());
                    }
                );
            }

            this.finishRenderHandler(this);
        },
        onFirstDataRendered(params) {
            const statestr = this.System.LocalStorage(this.storageKey + '-state');
            const stateObj = statestr ? JSON.parse(statestr) : null;
            const columnState = this.getSavedColumnState(stateObj);

            if (columnState) {
                params.api.applyColumnState({state: columnState, applyOrder: true});
                this.gridApi.setColumnGroupState(stateObj.columnGroupState);
                this.syncColumnsVisibleFromGrid();
            }
            else if (this.controlData.SizeColumnnsToContent)
                this.SizeColumnsToFit();
            else if (this.controlData.ColumnDefs)
                for (let i = 0; i < this.controlData.ColumnDefs.length; i++)
                    if (this.controlData.ColumnDefs[i].Width == 'SizeToContent' && this.controlData.ColumnDefs[i].Field)
                        this.gridApi.autoSizeColumns([this.controlData.ColumnDefs[i].Field]);

            const sortstr = this.System.LocalStorage(this.storageKey + '-sort');
            const sortObj = sortstr ? JSON.parse(sortstr) : null;
            const sortDef = this.columnDefs?.find(c => (this.controlData.DefaultSort && c.Field == this.controlData.DefaultSort) || (!this.controlData.DefaultSort && c.Sortable));
            
            if (sortObj) {
                this.gridApi.applyColumnState({ state: sortObj, applyOrder: false });
            } else if (sortDef && sortDef.Field) {
                const sort = [{ colId: sortDef.Field, sort: 'asc' }];
                this.gridApi.applyColumnState({ state: sort, applyOrder: false });
            }
                
            const column_filters = this.System.LocalStorage(this.storageKey + '-column_filters');
            const filterObj = column_filters ? JSON.parse(column_filters) : null;

            if (filterObj)
                this.gridApi.setFilterModel(filterObj);

            setTimeout(() => this.resolveAllAdditionalRowData(), 1000);
            //Vue.nextTick(() => this.resolveAllAdditionalRowData());

            if (this.controlData.OnFirstDataRendered)
                utils.executeAndCompileAllActions(this.controlData.OnFirstDataRendered, { Data: { FirstRow: params.firstRow, LastRow: params.lastRow } }, this);
        },
        SizeColumnsToFit() {
            this.gridApi.autoSizeAllColumns();
        },
        isServerSideModel(){
            return this.controlData.RowModelType == 'serverSide';
        },
        isAllSelected(){
            return !!this.serverSideSelectionState?.selectAll;
        },
        getServerSideSelectionState(){
            return this.serverSideSelectionState;
        },        
        getRowId(row){
            return this.controlData.KeyFields ? this.controlData.KeyFields.map(k => row[k]).join('_') : undefined;
        },
        rowSelectionChanged(e) {
            if(this.isServerSideModel() && this.controlData?.SelectOptions?.Enable){
                this.serverSideSelectionState = this.gridApi.getServerSideSelectionState();
                if(this.isAllSelected()){
                    this.selectedRowsData = [];
                    this.selected_rows = [];
                    
                    if (this.controlData.RowClassExpression)
                        this.gridApi.redrawRows();

                    return;
                }
            }
            const rows = this.gridApi.getSelectedNodes();

            utils.log(`rowSelectionChanged - ${rows.length} row(s) selected`);

            // rows[0].data
            // this.selectedRowKeys = rows.map(d => this.controlData.Keys.map(k => ({ [k]: d.data[k] })));

            if (this.controlData.KeyFields) {
                const selected_rows = {};
                for (let i = 0; i < rows.length; i++) {
                    const row = rows[i].data;
                    if(!row) continue;
                    const key = this.controlData.KeyFields.map(k => `_${row[k]}`).join('');
                    selected_rows[key] = row;
                }
                this.selected_rows = selected_rows;
            }
            this.selectedRowsData = rows.map(d => d.data);

            // If a row class expression is present, tell the grid to redraw in case the selection criteria affects the row class
            if (this.controlData.RowClassExpression)
                this.gridApi.redrawRows();
        },

        onSaveGridSortState(e) {
            if (!this.gridApi) return;

            let sortModel = this.gridApi.getColumnState().map(a => ({ colId: a.colId, sort: a.sort }));

            if (this.useLocalStorage) {
                this.System.LocalStorage(this.storageKey + '-sort', JSON.stringify(sortModel));
            }
        },
        onSaveGridColumnState: debounce(function (e) {
            if (!this.gridApi || (!e.column && e.type == 'columnMoved')) return;

            // Keep the menu checkbox state in sync when visibility is changed via AG Grid UI.
            if (e.type === 'columnVisible')
                this.syncColumnsVisibleFromGrid();

            let columnState = this.gridApi.getColumnState();
            let columnGroupState = this.gridApi.getColumnGroupState();

            const state = {
                columnState: columnState,
                columnGroupState: columnGroupState,
                portal: 'vue3',
            };

            if (this.useLocalStorage) {
                this.System.LocalStorage(this.storageKey + '-state', JSON.stringify(state));
            }
        }, 250),
    }
};

export default baseMixin;